import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

// Miles con coma y decimales con punto (1,234.56). El valor que se guarda
// no lleva comas, para que el API siga recibiendo un decimal.
export const formatoMonto = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const number = typeof value === "number" ? value : Number(String(value).replace(/,/g, ""));
    if (!Number.isFinite(number)) return "";
    return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const textoPlano = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return String(value).replace(/,/g, "");
};

// Mientras se escribe, la coma sola es el decimal. Si tambien hay punto,
// la coma es el separador de miles.
const entradaEditable = (text) => {
    const clean = String(text).replace(/\s/g, "");
    if (clean.includes(".")) return clean.replace(/,/g, "");
    const commas = (clean.match(/,/g) || []).length;
    if (commas <= 1) return clean.replace(",", ".");
    return clean.replace(/,/g, "");
};

const MontoTextField = ({
    value,
    name,
    onChange,
    inputProps,
    InputLabelProps,
    ...props
}) => {
    const [focused, setFocused] = useState(false);
    const [draft, setDraft] = useState("");
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        if (focused && !dirty) setDraft(textoPlano(value));
    }, [value, focused, dirty]);

    const emitir = (raw) => {
        onChange?.({ target: { name, value: raw } });
    };

    return (
        <TextField
            {...props}
            name={name}
            value={focused ? draft : formatoMonto(value)}
            onFocus={() => {
                setFocused(true);
                setDirty(false);
                setDraft(textoPlano(value));
            }}
            onChange={(event) => {
                const next = entradaEditable(event.target.value);
                if (next !== "" && !/^\d*\.?\d*$/.test(next)) return;
                setDirty(true);
                setDraft(next);
                emitir(next);
            }}
            onBlur={() => {
                setFocused(false);
                if (!dirty) return;
                if (draft === "" || draft === ".") {
                    emitir("");
                    return;
                }
                const number = Number(draft);
                if (!Number.isFinite(number)) {
                    emitir("");
                    return;
                }
                emitir(number.toFixed(2));
            }}
            inputProps={{
                ...inputProps,
                inputMode: "decimal",
                style: { textAlign: "right", ...(inputProps?.style || {}) },
            }}
            InputLabelProps={{ shrink: true, ...InputLabelProps }}
        />
    );
};

export default MontoTextField;
